import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NewsLetterModel } from '../Model/newsLetter.model';

@Injectable({
  providedIn: 'root'
})
export class NewsLetterService {

  private apiUrl = `${environment.apiUrl}NewsLetter/Create`

  private http = inject(HttpClient)

  createMessage(messageData: NewsLetterModel): Observable<any> {
    return this.http.post<any>(this.apiUrl, messageData);
  }

}
